import Vue from "vue";
import Vuex from "vuex";
import * as configError from "@/store/modules/configError.js";
import * as profile from "@/store/modules/profile.js";
// import requestServices from "@/store/modules/requestServices.js";

// import cloneDeep from "lodash/cloneDeep";
import {
  isEmpty,
  arrayDiff,
  getNested,
  checkNested,
  slotNumber,
} from "../utils/utils.js";

import axios from "axios";

import * as UltrixData from "./UltrixData.js";

Vue.use(Vuex);

function getPartData(arr) {
  let arr2 = [];
  for (let i = 0; i < arr.length; i++) {
    if (arr[i]?.obsolete == true) {
      continue;
    }
    let obj = { item: arr[i].item, desc: arr[i].desc, qty: arr[i].qty };
    if ("pMax" in arr[i]) {
      obj.pMax = arr[i].pMax;
    }
    arr2 = [...arr2, obj];
  }
  return arr2;
}
function addToItemTotal(list, ptNum, desc, type, addCount = 1) {
  // add ptNum to list and inc total by addCount
  // list = tally array of objects
  const idx = list.findIndex((x) => {
    return x.item === ptNum && x.type === type;
  });
  if (idx === -1) {
    list.push({ item: ptNum, type, desc, qty: addCount });
  } else {
    list[idx].qty += addCount;
  }
}
// const BCSregex = /ULTRICORE-BCS #\d/;
const getDefaultState = () => {
  return {
    frame: {
      limits: {
        maxVideoIn: 0,
        maxVideoOut: 0,
        maxAudioIn: 0,
        maxAudioOut: 0,
        maxUltriscape: 0,
        maxUltrisync: 0,
        maxUltrisrc: 0,
        maxVideoStream: 0,
        maxAudioStream: 0,
        minVideoIn: 0,
        minVideoOut: 0,
        minAudioIn: 0,
        minAudioOut: 0,
        maxSlots: 0,
      },
      // bundleid: ""
    },
    services: JSON.parse(JSON.stringify(UltrixData.services)),
    parts: getParts(),
    switchers: [],
    VAC: null,
  };
};

const getParts = () => {
  let prts = [];
  let fp = JSON.parse(JSON.stringify(UltrixData.frameParts));
  let cp = JSON.parse(JSON.stringify(UltrixData.controlParts));
  let ip = JSON.parse(JSON.stringify(UltrixData.installParts));
  // let fo = getPartData(UltrixData.frameOptions);
  prts.push(...getPartData(fp));
  prts.push(...getPartData(cp));
  prts.push(...getPartData(ip));
  return prts;
};

/***
 * get ultrixData ioModule
 */
function UltrixDataioModule(modType) {
  const mod = UltrixData.ioModules.find(({ type }) => type === modType);
  if (mod != undefined) {
    return JSON.parse(JSON.stringify(mod));
  }
  return null;
}
export default new Vuex.Store({
  modules: {
    configError,
    profile,
  },
  // strict: true,
  state: getDefaultState(),

  getters: {
    getFrame(state) {
      return state.frame;
    },
    /*  getUltrixDataBCS() {
      return Object.freeze(UltrixData.BCS);
    }, */

    getFrameSize(state) {
      //returns 'x' frame size from frame model string FRx
      if (state.frame.model) {
        let patt = /(FR)(\d+)/;
        let res = patt.exec(state.frame.model);
        return res[2];
      } else {
        return 0;
      }
    },
    getFrameType(state) {
      if (state.frame.model) {
        const frm = state.frame.model;
        let position = frm.search(/NS-|FR\d+/);
        return frm.slice(position);
      } else {
        return null;
      }
    },
    getFrameLicenseLimits(state) {
      let limits = {
        maxUscape: 0,
        maxUsync: 0,
        maxUsyncUHD: 0,
        maxUproc: 0,
        maxUprocIn: 0,
        maxUprocUHD: 0,
        maxUprocUHDIn: 0,
      };
      for (const slot in state.frame.modules) {
        if (Object.hasOwn(state.frame.modules, slot)) {
          if (!slot.includes("slot")) continue;

          const curCard = state.frame.modules[slot];
          if (!curCard?.type || curCard.type.includes("BLANK")) continue;
          let ioType;
          if (curCard?.licenses?.ultriprocHDR) {
            ioType = curCard?.licenses?.ultriprocHDR.ioType;
          }
          if (curCard?.modules) {
            limits.maxUsync += 2; //aux usync
            limits.maxUsyncUHD += 2; //aux UscynUhd
            for (const submodPos in curCard.modules) {
              if (Object.hasOwn(curCard.modules, submodPos)) {
                const l = curCard.modules[submodPos]?.limits?.licenses;
                if (l) {
                  if (["slotA", "slotB", "slotD"].includes(submodPos)) {
                    limits.maxUscape += l.scape || 0;
                  }

                  limits.maxUsync += l.sync || 0;
                  limits.maxUsyncUHD += l.syncUhd || 0;
                  limits.maxUproc += l.proc || 0;
                  limits.maxUprocUHD += l.procUhd || 0;
                  if (curCard.modules[submodPos]?.model !== "ULTRIX-MOD-DPT") {
                    limits.maxUprocIn += l.proc || 0;
                    limits.maxUprocUHDIn += l.procUhd || 0;
                  }
                }
              }
            }
          } else {
            const licenses = curCard.limits?.licenses;
            if (licenses) {
              limits.maxUscape += licenses.scape || 0;
              limits.maxUsync += licenses.sync || 0;
              limits.maxUsyncUHD += licenses.syncUhd || 0;
              limits.maxUproc += licenses.proc || 0;
              limits.maxUprocUHD += licenses.procUhd || 0;
              limits.maxUprocIn += licenses.proc || 0;
              limits.maxUprocUHDIn += licenses.procUhd || 0;
            }
          }
        }
      }
      return limits;
    },
    // getMaxSlots(state) {
    //   return state.frame.limits.maxSlots;
    // },
    getFrameLicenses(state) {
      if (typeof state.frame.frameLicenses != "undefined") {
        // console.log("fr", state.frame.frameLicense);
        return state.frame.frameLicenses;
      } else {
        return {}; //false;
      }
    },
    isUltrispeed(state) {
      const res = state.frame.frameLicenses.find(({ item }) =>
        item.includes("ULTRISPEED")
      );
      return res.qty == 0 ? false : true;
    },

    getLicenseTotals(state) {
      let Lic = {
        uscapeLicenses: 0,
        usyncLicenses: 0,
        usyncUhdLicenses: 0,
        uprocLicenses: 0,
        uprocUhdLicenses: 0,
        uproc3DLicenses: 0,
        uproc3DUhdLicenses: 0,
        ustreamOutLicenses: 0,
        umixDanteLicenses: 0,
        usrcLicenses: 0,
        vidprocHD: 0,
        vidprocUHD: 0,
        DDVE: 0,
        SWRCarb: { ME1: 0, ME2: 0, PACC: 0, FSFC: 0, UHD: 0, MOSAIC: 0 },
        swrHyperMax: { MaxME: 0 },
      };

      for (let i = 0; i < state.frame.limits.maxSlots + 1; i++) {
        if (typeof state.frame.modules["slot" + i] != "undefined") {
          let curSlot = state.frame.modules["slot" + i];
          // if (typeof curSlot.defaults != "undefined") {
          if (Object.hasOwn(curSlot, "ultriscapeLicenses")) {
            Lic.uscapeLicenses += curSlot.ultriscapeLicenses.length;
          }

          if (Object.hasOwn(curSlot, "ultrisyncLicenses")) {
            Lic.usyncLicenses += curSlot.ultrisyncLicenses.length;
          }
          if (Object.hasOwn(curSlot, "ultrisyncUhdLicenses")) {
            Lic.usyncUhdLicenses += curSlot.ultrisyncUhdLicenses.length;
          }
          if (Object.hasOwn(curSlot, "ultrisrcLicenses")) {
            Lic.usrcLicenses += curSlot.ultrisrcLicenses.length;
          }
          if (!curSlot?.licenses) continue;
          const n = getNested(
            curSlot,
            "licenses",
            "ultriprocHDR",
            "positions",
            "length"
          );

          if (n && n > 0) {
            if (curSlot.licenses.ultriprocHDR.ioRate == "uhd") {
              //uhd rate
              Lic.uprocUhdLicenses += n;
            }
            //total inc hd and uhd
            Lic.uprocLicenses += n;
          }
          const d = getNested(
            curSlot,
            "licenses",
            "ultriproc3D",
            "positions",
            "length"
          );

          if (d && d > 0) {
            if (curSlot.licenses.ultriproc3D.ioRate == "uhd") {
              Lic.uproc3DUhdLicenses += d;
            }
            Lic.uproc3DLicenses += d; //total inc hd and uhd
          }
          const u = getNested(
            curSlot,
            "licenses",
            "ultristreamOut",
            "positions",
            "length"
          );
          if (u && u > 0) {
            Lic.ustreamOutLicenses += u;
          }

          const m = getNested(
            curSlot,
            "licenses",
            "ultrimixDante",
            "positions",
            "length"
          );
          if (m && m > 0) {
            Lic.umixDanteLicenses += m;
          }

          if (curSlot.type === "Acuity" && Object.hasOwn(curSlot, "licenses")) {
            // let m = curSlot.licenses.format.value;
            if (curSlot.licenses["UHD-ME"]) {
              Lic.vidprocUHD += curSlot.licenses["UHD-ME"].qty;
            }
            if (curSlot.licenses["HD-ME"]) {
              Lic.vidprocHD += curSlot.licenses["HD-ME"].qty;
            }

            if (curSlot.licenses["ACUFR-3DDVE-LIC"]) {
              Lic.DDVE += curSlot.licenses["ACUFR-3DDVE-LIC"].qty;
            }
          }
          if (
            curSlot.type === "Carbonite" &&
            Object.hasOwn(curSlot, "licenses")
          ) {
            for (let license in curSlot.licenses) {
              if (curSlot.licenses[license].qty > 0) {
                Lic.SWRCarb[license] += curSlot.licenses[license].qty;
              }
            }
          }
          if (curSlot.type === "HyperMax" && curSlot.licenses) {
            for (let license in curSlot.licenses) {
              if (curSlot.licenses[license].qty > 0) {
                Lic.swrHyperMax[license] += curSlot.licenses[license].qty;
              }
            }
          }
          // }
        }
      }
      //ACUFR licenses
      Lic.MACD = [];
      if (state.frame.modules.macd?.licenses) {
        for (const licType in state.frame.modules.macd.licenses) {
          if (Object.hasOwn(state.frame.modules.macd.licenses, licType)) {
            if (state.frame.modules.macd.licenses[licType].qty > 0) {
              Lic.MACD.push(state.frame.modules.macd.licenses[licType]);
            }
          }
        }
      }

      for (let fl = 0; fl < state.frame.frameLicenses.length; fl++) {
        const obj = state.frame.frameLicenses[fl];
        Lic[obj.item] = obj.qty;
      }
      return Lic;
    },
    getUltrixPS(state) {
      return state.parts.find(function (part) {
        return part.item == "ULTRIX-PS";
      });
    },
    getUltripowerPS(state) {
      return state.parts.find(function (part) {
        return part.item == "ULTRIPOWER-PS";
      });
    },
    getUltripower(state) {
      return state.parts.find(function (part) {
        return part.item == "ULTRIPOWER";
      });
    },
    getMinPSU(state, getters) {
      let u = {
        "ULTRIX-PS": 0,
        ULTRIPOWER: 0,
        "ULTRIPOWER-PS": 0,
        swrUPWR: 0,
      };
      let minPSU = {};
      const psu = getNested(state.frame, "limits", "psu");

      if (psu) {
        if (state.frame.psRedundancy == 1) {
          minPSU = { ...u, ...psu.redun };
        } else {
          minPSU = { ...u, ...psu.std };
        }
      }
      let swrMin = Math.ceil(Number(getters.getSwrCount) / 4);
      //dont add redun ps
      /* if (swrMin) {
        minPSU["ULTRIPOWER-PS"] = swrMin;
      } */

      //if FR2 over two bricks (500W) add Upwr or if SWR included
      if (getters.getFrameSize == "2") {
        if (getters.getFramePower.powerMax > 480 || swrMin) {
          minPSU["ULTRIPOWER"] += swrMin | 1;
        }
      }
      const SDXEcount = getters.getIOCountByType("SWR-SDxE (Acuity)");
      if (getters.getFrameSize == "5") {
        if (getters.getFramePower.powerMax > 1020 || SDXEcount > 0) {
          minPSU["ULTRIPOWER"] += 1;
        }
        if (getters.getFramePower.powerMax > 1600 && SDXEcount > 0) {
          minPSU["ULTRIPOWER"] += 1; //add third if SDXE uses 2 pwr connections
        }
      }
      //dont add Upwr with SWR
      if (getters.getFrameSize == "12") {
        // if (SDXEcount > 0) {
        //   minPSU["ULTRIPOWER"] += 1;
        // }
        const powerPoint1 = SDXEcount > 0 ? 1680 : 2280;
        const powerPoint2 = SDXEcount > 0 ? 2700 : 3300;
        if (getters.getFramePower.powerMax > powerPoint1) {
          minPSU["ULTRIPOWER"] += 1;
        }
        if (getters.getFramePower.powerMax > powerPoint2) {
          minPSU["ULTRIPOWER"] += 1;
        }
      }
      // if (getters.getIOCountByType("SWR-SDxE") > 0) {
      //   minPSU["ULTRIPOWER"] += 1;
      // }
      return minPSU;
    },

    getSlotLicenses(state) {
      return (slot) => {
        const uStreamOut = getNested(
          state.frame.modules[slot],
          "licenses",
          "ultristreamOut"
        );
        const uProcHDR = getNested(
          state.frame.modules[slot],
          "licenses",
          "ultriprocHDR"
        );
        const uProc3D = getNested(
          state.frame.modules[slot],
          "licenses",
          "ultriproc3D"
        );
        const uDante = getNested(
          state.frame.modules[slot],
          "licenses",
          "ultrimixDante"
        );
        const slotType = getNested(state.frame.modules[slot], "model");
        return {
          ultriscape:
            "ultriscapeLicenses" in state.frame.modules[slot]
              ? state.frame.modules[slot].ultriscapeLicenses
              : [],
          ultrisync:
            "ultrisyncLicenses" in state.frame.modules[slot]
              ? state.frame.modules[slot].ultrisyncLicenses
              : [],
          ultrisyncuhd:
            "ultrisyncUhdLicenses" in state.frame.modules[slot]
              ? state.frame.modules[slot].ultrisyncUhdLicenses
              : [],
          ultrisrc:
            "ultrisrcLicenses" in state.frame.modules[slot]
              ? state.frame.modules[slot].ultrisrcLicenses
              : [],
          meLicense:
            "meLicense" in state.frame.modules[slot]
              ? state.frame.modules[slot].meLicense
              : [],
          licenses:
            slotType == "SWR-SDPE" && "licenses" in state.frame.modules[slot]
              ? state.frame.modules[slot].licenses
              : [],
          ultristreamOut: uStreamOut ? uStreamOut.positions : [],
          ultriprocHDR: uProcHDR ? uProcHDR.positions : [],
          ultriproc3D: uProc3D ? uProc3D.positions : [],
          ultrimixDante: uDante ? uDante.positions : [],
        };
      };
    },
    getPortLicenses(state) {
      //args ex:  slot= 'slot3'  port= 'Aux.A'
      return function (slot, port) {
        // console.log(slot, port);
        //check for subSlot eg port has slotA.port1 format
        // let subSlot=port.includes('.');
        let portLicenses = [];

        if (state.frame.modules[slot].ultriscapeLicenses.indexOf(port) != -1) {
          portLicenses.push("ultriscape");
        }

        if (state.frame.modules[slot].ultrisrcLicenses.indexOf(port) != -1) {
          portLicenses.push("ultrisrc");
        }

        if (state.frame.modules[slot].ultrisyncLicenses.indexOf(port) != -1) {
          portLicenses.push("ultrisync");
        }
        if (
          state.frame.modules[slot].ultrisyncUhdLicenses.indexOf(port) != -1
        ) {
          portLicenses.push("ultrisyncuhd");
        }

        return portLicenses;
      };
    },

    getBOMReport(state, getters) {
      let frame = [],
        slots = [],
        sfp = [];

      if (isEmpty(state.frame)) {
        return;
      }
      let bundle = getNested(state.frame, "bundleid");
      let frameItem =
        bundle && bundle != "" ? state.frame.bundleid : state.frame.model;

      frame.push({
        item: frameItem,
        desc: state.frame.description,
        qty: 1,
      });
      let doubleModuleCount = 0;
      // console.log("state", state.frame.modules);
      for (const slotid in state.frame.modules) {
        if (typeof state.frame.modules[slotid] != "undefined") {
          if (Object.entries(state.frame.modules[slotid]).length != 0) {
            // SFP ports
            let sfpPort =
              typeof state.frame.modules[slotid].sfpPorts != "undefined"
                ? state.frame.modules[slotid].sfpPorts
                : {};
            // let sfpPort = state.frame.modules["slot" + i].sfpPorts;
            for (let key in sfpPort) {
              if (!isEmpty(sfpPort[key])) {
                let s = sfpPort[key];
                addToItemTotal(sfp, s.model, s.description, s.type);
              }
            }
            //MODXIO submodules
            let subModules = getNested(state.frame.modules[slotid], "modules");
            if (subModules) {
              for (const subModulePos in subModules) {
                if (
                  Object.hasOwnProperty.call(subModules, subModulePos) &&
                  !isEmpty(subModules[subModulePos])
                ) {
                  const subMod = subModules[subModulePos];
                  addToItemTotal(
                    slots,
                    subMod.model,
                    subMod.description,
                    subMod.type
                  );
                }
                let subModulePorts = getNested(
                  subModules[subModulePos],
                  "sfpPorts"
                );
                if (subModulePorts) {
                  for (const port in subModulePorts) {
                    if (
                      Object.hasOwn(subModulePorts, port) &&
                      !isEmpty(subModulePorts[port])
                    ) {
                      const subModuleSfp = subModulePorts[port];
                      addToItemTotal(
                        sfp,
                        subModuleSfp.model,
                        subModuleSfp.description,
                        subModuleSfp.type
                      );
                    }
                  }
                }
              }
            }

            const {
              model: slotModel,
              type: slotType,
              description: slotDesc,
            } = state.frame.modules[slotid];

            // if (slotModel == "SWR-SDXE") {
            //   doubleModuleCount++;
            // }
            //dont add MIOB nor FR5 cpu1
            if (slotType != "MIOB") {
              switch (slotModel) {
                case "ACUFR-CPU":
                case "ACUFR12-CPU":
                  let lic = state.frame.modules[slotid].licenses;
                  let slotLic = [];
                  Object.keys(lic).map(function (key) {
                    if (lic[key].qty > 0) {
                      slotLic.push({
                        item: key,
                        desc: lic[key].desc,
                        qty: lic[key].qty,
                      });
                    }
                  });
                  slots.push({
                    item: slotModel,
                    desc: slotDesc,
                    qty: 1,
                    licenses: slotLic,
                  });
                  break;

                default:
                  addToItemTotal(slots, slotModel, slotDesc, slotType);
              }
            }
          }
        }
        if (
          state.frame.modules[slotid].model == "SWR-SDXE" &&
          state.frame.model == "ULTRIX-FR12"
        ) {
          if (slotid == "slot8" || slotid == "slot9") {
            doubleModuleCount++;
          }
        }
      }

      //if fr12 recalc io blank qty
      if (state.frame.model == "ULTRIX-FR12" && doubleModuleCount < 2) {
        // let extraBlanks=2-doubleModuleCount;
        const idx = slots.findIndex((obj) => obj.item == "ULTRIX-IO-BP");
        const modxCount = getters.getIOCountByType("MODXIO");
        if (idx > -1) {
          slots[idx].qty += 2 - doubleModuleCount;
        } else {
          if (modxCount > 0) {
            addToItemTotal(
              slots,
              "ULTRIX-IO-BAF",
              "Blanking plate baffle - Standard IO slot",
              "BLANK-IO-BAF",
              2 - doubleModuleCount
            );
          } else {
            addToItemTotal(
              slots,
              "ULTRIX-IO-BP",
              "Ultrix IO Blank Panel (Cover Plate)",
              "BLANK",
              2 - doubleModuleCount
            );
          }
        }
      }

      //sort slot contents by item
      slots.sort((a, b) => (a.item > b.item ? 1 : b.item > a.item ? -1 : 0));

      let licenses = getters.getLicenseTotals;
      //parts

      var parts = [];

      state.parts.forEach((part) => {
        let partLic = [];
        switch (part.item) {
          case "ULTRICORE-BCS":
            if (part.licenses != undefined) {
              Object.keys(part.licenses).forEach((key) => {
                if (part.licenses[key].qty > 0) {
                  partLic.push({
                    item: key,
                    desc: part.licenses[key].desc,
                    qty: part.licenses[key].qty,
                  });
                }
              });
            }
            parts.push({
              item: part.item + " #" + part.id,
              desc: "Ultricore HW controller Platform ",
              qty: 1,
              licenses: partLic,
            });
            break;
          case "TLY-TSI4000-ACO":
          case "TLY-TSI4000-CP":
            if (part.licenses != undefined) {
              part.licenses.forEach((element) => {
                if (element.qty > 0) {
                  partLic.push({
                    item: element.type,
                    desc: element.desc,
                    qty: element.qty,
                  });
                }
              });
            }
            parts.push({
              item: part.item, //+ " #" + part.id,
              desc: part.desc,
              qty: 1,
              licenses: partLic,
            });
            break;
          default:
            if (part.qty > 0 && part.item != "ULTRIX-SHIP_KIT") {
              parts.push(part);
            }
            break;
        }
      });
      /**services */
      let services = [];
      state.services.forEach((service) => {
        if (service.qty > 0) {
          services.push({
            item: service.item,
            desc: service.desc,
            qty: service.qty,
          });
        }
      });
      let switchers = [];
      state.switchers.forEach((switcher) => {
        if (switcher.qty > 0) {
          switchers.push({
            item: switcher.item,
            desc: switcher.desc,
            qty: switcher.qty,
          });
        }
      });

      return {
        frame: frame,
        cards: slots,
        licenses: licenses,
        sfp: sfp,
        parts: parts,
        services: services,
        switchers: switchers,
      };
    },

    getMatrixSize(state, getters) {
      let totalMtxIn = 0,
        totalMtxOut = 0,
        totalIPUHDtwelve = 0,
        totalIPUHDsix = 0,
        totalIPHD = 0,
        totalSDIin = 0,
        totalSDItwelveIn = 0,
        totalSDIout = 0,
        totalSDItwelveOut = 0,
        totalAin = 0,
        totalAout = 0,
        totalMADIin = 0,
        totalMADIout = 0;

      for (const slotn in state.frame.modules) {
        if (Object.hasOwn(state.frame.modules, slotn)) {
          if (!Object.hasOwn(state.frame.modules[slotn], "model")) {
            continue;
          }
          const curSlot = state.frame.modules[slotn];
          const slotUscape = getters.getSlotLicenses(slotn);
          switch (curSlot.type) {
            case "HDBNC":
            case "HDXIO":
            case "MIOB":
            case "SFPIO":
              totalSDIin += curSlot.defaults.videoIn;
              totalSDIout += curSlot.defaults.videoOut;
              if (getters.isUltrispeed) {
                totalSDItwelveIn += curSlot.defaults.videoIn;
                totalSDItwelveOut += curSlot.defaults.videoOut;
              }
              //calc sfp modules
              for (const y in curSlot.sfpPorts) {
                // console.log(y, curSlot.sfpPorts[y]);
                const thisSFP = curSlot.sfpPorts[y];
                if (!isEmpty(thisSFP)) {
                  if (slotn == "slot0") {
                    continue;
                  }
                  // console.log("we got something in", slotn, y);
                  const danteLicAssigned = getNested(
                    state.frame.modules,
                    slotn,
                    "licenses",
                    "ultrimixDante",
                    "positions"
                  );
                  if (danteLicAssigned && danteLicAssigned.indexOf(y) != -1) {
                    totalMADIout += 64;
                    totalMADIin += 64;
                  }
                  if (thisSFP.videoIn === 0 && thisSFP.videoOut === 0) {
                    //if no video then it must be MADI
                    totalMADIout += thisSFP.audioOut;
                    totalMADIin += thisSFP.audioIn;
                  } else {
                    if (
                      getNested(thisSFP, "licenseApplicable", "ultrispeed") ==
                        1 &&
                      getters.isUltrispeed
                    ) {
                      //uhd capable and enabled
                      totalSDItwelveIn += thisSFP.videoIn;
                      totalSDItwelveOut += thisSFP.videoOut;
                    }
                    totalMtxIn += thisSFP.videoIn;
                    totalSDIin += thisSFP.videoIn;
                    totalMtxOut += thisSFP.videoOut;
                    totalSDIout += thisSFP.videoOut;
                    totalAin += thisSFP.audioIn;
                    totalAout += thisSFP.audioOut;
                  }
                }
              }
              //decrease for uScape head output
              if (slotUscape.ultriscape.length > 0) {
                totalMtxOut -= slotUscape.ultriscape.length;
                totalSDIout -= slotUscape.ultriscape.length;
                if (totalSDItwelveOut > 0) {
                  totalSDItwelveOut -= slotUscape.ultriscape.length;
                }
              }
              break;

            case "IPIO":
              // IPIO doesnt calc sfp or SDI/Audio qty's
              totalIPUHDtwelve += 4;
              totalIPUHDsix += 4;
              totalIPHD += 16;

              break;
            case "IPXIO":
              // IPIO doesnt calc sfp or SDI/Audio qty's
              totalIPUHDtwelve += 16;
              totalIPUHDsix += 16;
              totalIPHD += 16;
              break;
            case "MODXIO":
              // MODXIO AUX ports
              for (const auxPort in curSlot.sfpPorts) {
                // console.log(y, curSlot.sfpPorts[y]);
                const thisSFP = curSlot.sfpPorts[auxPort];
                if (!isEmpty(thisSFP)) {
                  // console.log("we got something in", slotn, y);
                  const danteLicAssigned = getNested(
                    state.frame.modules,
                    slotn,
                    "licenses",
                    "ultrimixDante",
                    "positions"
                  );
                  if (
                    danteLicAssigned &&
                    danteLicAssigned.indexOf(auxPort) != -1
                  ) {
                    totalMADIout += 64;
                    totalMADIin += 64;
                  }
                  if (thisSFP.videoIn === 0 && thisSFP.videoOut === 0) {
                    //if no video then it must be MADI
                    totalMADIout += thisSFP.audioOut;
                    totalMADIin += thisSFP.audioIn;
                  } else {
                    if (
                      getNested(thisSFP, "licenseApplicable", "ultrispeed") ==
                        1 &&
                      getters.isUltrispeed
                    ) {
                      //uhd capable and enabled
                      totalSDItwelveIn += thisSFP.videoIn;
                      totalSDItwelveOut += thisSFP.videoOut;
                    }
                    totalMtxIn += thisSFP.videoIn;
                    totalSDIin += thisSFP.videoIn;
                    totalMtxOut += thisSFP.videoOut;
                    totalSDIout += thisSFP.videoOut;
                    totalAin += thisSFP.audioIn;
                    totalAout += thisSFP.audioOut;
                  }
                }
              }
              //MODXIO submodules
              let subModules = getNested(state.frame.modules[slotn], "modules");
              if (subModules) {
                for (const subModulePos in subModules) {
                  if (
                    Object.hasOwn(subModules, subModulePos) &&
                    !isEmpty(subModules[subModulePos])
                  ) {
                    const subMod = subModules[subModulePos];
                    switch (subMod.type) {
                      case "MODXSFP":
                        let subModulePorts = getNested(
                          subModules[subModulePos],
                          "sfpPorts"
                        );
                        if (subModulePorts) {
                          for (const port in subModulePorts) {
                            if (
                              Object.hasOwn(subModulePorts, port) &&
                              !isEmpty(subModulePorts[port])
                            ) {
                              const thisSFP = subModulePorts[port];

                              if (
                                thisSFP.videoIn === 0 &&
                                thisSFP.videoOut === 0
                              ) {
                                //if no video then it must be MADI
                                totalMADIout += thisSFP.audioOut;
                                totalMADIin += thisSFP.audioIn;
                              } else {
                                if (
                                  getNested(
                                    thisSFP,
                                    "licenseApplicable",
                                    "ultrispeed"
                                  ) == 1 &&
                                  getters.isUltrispeed
                                ) {
                                  //uhd capable and enabled
                                  totalSDItwelveIn += thisSFP.videoIn;
                                  totalSDItwelveOut += thisSFP.videoOut;
                                }
                                totalMtxIn += thisSFP.videoIn;
                                totalSDIin += thisSFP.videoIn;
                                totalMtxOut += thisSFP.videoOut;
                                totalSDIout += thisSFP.videoOut;
                                totalAin += thisSFP.audioIn;
                                totalAout += thisSFP.audioOut;
                              }
                            }
                          }
                        }
                        break;

                      case "MODXSDI":
                        totalSDIin +=
                          curSlot.modules[subModulePos].defaults.videoIn;
                        totalAin +=
                          curSlot.modules[subModulePos].defaults.audioIn;
                        totalSDIout +=
                          curSlot.modules[subModulePos].defaults.videoOut;
                        totalAout +=
                          curSlot.modules[subModulePos].defaults.audioOut;
                        totalMtxIn +=
                          curSlot.modules[subModulePos].defaults.videoIn;
                        totalMtxOut +=
                          curSlot.modules[subModulePos].defaults.videoOut;
                        if (getters.isUltrispeed) {
                          totalSDItwelveIn +=
                            curSlot.modules[subModulePos].defaults.videoIn;
                          totalSDItwelveOut +=
                            curSlot.modules[subModulePos].defaults.videoOut;
                        }
                        break;
                      case "MODXNDI":
                        totalIPHD += 4;
                        break;
                      default:
                        break;
                    }
                  }
                }
              }
              //decrease for uScape head output
              if (slotUscape.ultriscape.length > 0) {
                totalMtxOut -= slotUscape.ultriscape.length;
                totalSDIout -= slotUscape.ultriscape.length;
                if (totalSDItwelveOut > 0) {
                  totalSDItwelveOut -= slotUscape.ultriscape.length;
                }
              }
              break;
          }
          if (Object.hasOwn(curSlot, "defaults")) {
            totalMtxIn += curSlot.defaults.videoIn;
            totalMtxOut += curSlot.defaults.videoOut;
            totalAin += curSlot.defaults.audioIn;
            totalAout += curSlot.defaults.audioOut;
          }
          if (slotn === "slot0" && curSlot.type === "IPIO") {
            //if IPIO in flex only 15 IO.  IO #8 is not internally routed - reduce totals x1
            totalIPHD -= 1;
            totalMtxIn -= 1;
            totalMtxOut -= 1;
          }
        }
      }
      return {
        totalMtxIn,
        totalMtxOut,
        totalSDIin,
        totalSDItwelveIn,
        totalSDIout,
        totalSDItwelveOut,
        totalAin,
        totalAout,
        totalMADIin,
        totalMADIout,
        totalIPUHDtwelve,
        totalIPUHDsix,
        totalIPHD,
      };
    },
    getSlotsInUse(state) {
      let populatedslots = [];

      // start loop from frame maxSlots and count down.
      let i = state.frame.limits.maxSlots;
      let fin = 0;
      if (
        state.frame.model === "ULTRIX-FR5" ||
        state.frame.model === "ULTRIX-NS-FR5"
      ) {
        i--;
        fin = -1;
      }

      for (i; i > fin; i--) {
        // let slotn = "slot" + i;
        if (isEmpty(state.frame.modules["slot" + i])) {
          populatedslots.push({
            slot: i,
            type: "BLANK",
            model: "ULTRIX-IO-BP",
          });
        } else {
          populatedslots.push({
            slot: i,
            type: state.frame.modules["slot" + i].type,
            model: state.frame.modules["slot" + i].model,
          });
        }
      }

      return populatedslots;
    },
    getUltrispeedSFPs() {
      return UltrixData.SFP.filter(
        ({ licenseApplicable }) =>
          licenseApplicable.ultrispeed != "undefined" &&
          licenseApplicable.ultrispeed == 1
      );
    },
    getUsrcPorts(state) {
      const srcCardTypes = ["HDXIO", "MIOB", "HDBNC", "SFPIO", "MODXIO"];
      let availableUsrc = [];
      let assignedUsrc = [];
      for (let n = 1; n < state.frame.limits.maxSlots + 1; n++) {
        //dont count slot0 as AUXA, AUXB are NA
        let currentCardType = getNested(
          state.frame.modules,
          "slot" + n,
          "type"
        );
        if (!currentCardType) {
          continue;
        }
        if (srcCardTypes.includes(currentCardType)) {
          //we got an applic card installed at slot n
          //does it have MADI port - currently only AuxA and AuxB
          const auxAPort = getNested(
            state.frame.modules,
            "slot" + n,
            "sfpPorts",
            "AUXA"
          );
          const isAuxAUsrc = getNested(
            auxAPort,
            "licenseApplicable",
            "ultrisrc"
          );
          if (isAuxAUsrc > 0 || isEmpty(auxAPort)) {
            //sfp is MADI applicable or there is no sfp
            availableUsrc.push("slot" + n + ",AUXA");
          }

          const slotUdanteCount =
            getNested(
              state.frame.modules,
              "slot" + n,
              "licenses",
              "ultrimixDante",
              "positions",
              "length"
            ) || 0;
          const auxBPort = getNested(
            state.frame.modules,
            "slot" + n,
            "sfpPorts",
            "AUXB"
          );
          const isAuxBUsrc = getNested(
            auxBPort,
            "licenseApplicable",
            "ultrisrc"
          );
          if (slotUdanteCount == 0 && (isAuxBUsrc > 0 || isEmpty(auxBPort))) {
            availableUsrc.push("slot" + n + ",AUXB");
          }
          state.frame.modules["slot" + n].ultrisrcLicenses.forEach((port) => {
            assignedUsrc.push("slot" + n + "," + port);
          });
        }
      }
      // let diff = arrayDiff(availableUsrc, assignedUsrc);
      return { availableUsrc: availableUsrc, assignedUsrc: assignedUsrc };
    },
    getUscapePorts(state, getters) {
      let assignedUscape = [];
      let freeUscapeGroups = {}; // free portGroups including empty or compatible sfp

      for (const slot in state.frame.modules) {
        const u = getNested(state.frame.modules, slot, "ultriscapeLicenses");
        if (u) {
          u.forEach((p) => {
            assignedUscape.push(`${slot}.${p}`);
          });
          // }
          freeUscapeGroups[slot] = [];
          const UscapeGrps = getNested(
            state.frame.modules,
            slot,
            "limits",
            "uscape_ports"
          );
          const s = getters.getSFPInUse; // to trigger update when sfp changes
          // const sMod = getNested(state.frame.modules, slot, "modules");
          if (UscapeGrps) {
            let uscapegrps = JSON.parse(JSON.stringify(UscapeGrps));
            uscapegrps.forEach((grp) => {
              let idx = grp.findIndex((el) => el.includes("slot"));
              if (idx > -1) {
                //test if subslot fitted
                const slotport = grp[idx].split(".");
                const subSlotModule = getNested(
                  state.frame.modules,
                  slot,
                  "modules",
                  slotport[0],
                  "type"
                );

                if (!subSlotModule || subSlotModule == "BLANK") {
                  grp.splice(idx, 1);
                }
                //is MODSFP and is compat sfp fitted
                if (subSlotModule == "MODXSFP") {
                  const isSfp = getNested(
                    state.frame.modules,
                    slot,
                    "modules",
                    slotport[0],
                    "sfpPorts",
                    slotport[1],
                    "licenseApplicable"
                  );
                  if (isSfp && !isSfp.ultriscape) {
                    grp.splice(idx, 1);
                  }
                }
              }
              idx = grp.findIndex((el) => el.includes("AUX"));
              if (idx > -1) {
                const isSfp = getNested(
                  state.frame.modules,
                  slot,
                  "sfpPorts",
                  grp[idx],
                  "licenseApplicable"
                );
                if (slot == "slot0") {
                  grp.splice(idx, 1);
                } else if (isSfp && !isSfp.ultriscape) {
                  grp.splice(idx, 1);
                }
              }

              if (grp.length > 0) {
                let intersection = grp.filter((x) => u.includes(x));
                if (intersection.length == 0) {
                  freeUscapeGroups[slot].push(grp);
                }
              }
            });
          }
        }
      }
      return {
        assignedUscape: assignedUscape,
        freeUscapeGroups: freeUscapeGroups,
      };
    },
    getSFPInUse(state) {
      let sfpMap = {};

      for (const slot in state.frame.modules) {
        sfpMap[slot] = [];
        let count = 0;
        if (getNested(state.frame.modules, slot, "limits")) {
          const sfpPorts = getNested(state.frame.modules, slot, "sfpPorts");
          if (sfpPorts) {
            for (const port in sfpPorts) {
              const model = getNested(sfpPorts, port, "model");
              if (model) {
                sfpMap[slot].push(model);
                // sfpMap[slot] = ++count;
              }
            }
          }
          const subMods = getNested(state.frame.modules, slot, "modules");
          if (subMods) {
            for (const subMod in subMods) {
              const subModule = getNested(subMods, subMod);
              if (subModule.type === "MODXSFP") {
                for (const p in subModule.sfpPorts) {
                  const model = getNested(subModule.sfpPorts, p, "model");
                  if (model) {
                    sfpMap[slot].push(model);
                    // sfpMap[slot] = ++count;
                  }
                }
              }
            }
          }
        }
      }
      return sfpMap;
    },
    getFramesyncPorts(state, getters) {
      let freeUsync = [];
      let assignedUsync = [];
      let freeUsyncUHD = [];
      let assignedUsyncUHD = [];

      const frameSyncCardTypes = ["MIOB", "HDBNC", "HDXIO", "MODXIO", "SFPIO"];

      //for each slot in frame
      /* idea
      for (let n = 0,k=state.frame.limits.maxSlots-1; n < state.frame.limits.maxSlots && K>=0; n++,k--) {
      if frameSize=1 || frameSize=2 //bottom up
      currentSlot='slot'+k
      else curentSlot='slot'+n //FR5/12 top down */

      for (let n = 0; n < state.frame.limits.maxSlots + 1; n++) {
        // if (Object.hasOwn(state.frame.modules, "slot" + n)) {
        // if (Object.hasOwn(state.frame.modules["slot" + n], "limits")) {
        if (getNested(state.frame.modules, `slot${n}`, "limits")) {
          //we have a card fitted
          if (
            frameSyncCardTypes.includes(state.frame.modules["slot" + n].type)
          ) {
            //we got module that supports Ultrisync
            const moduleType = state.frame.modules["slot" + n].type;

            let defaultPorts = [];
            switch (moduleType) {
              case "SFPIO":
                for (let i = 1; i < 17; i++) {
                  defaultPorts.push(`port${i}`);
                }
                break;
              case "MODXIO":
                const arr = ["A", "B", "C", "D"];
                for (let s = 0; s < 4; s++) {
                  for (let p = 1; p < 5; p++) {
                    defaultPorts.push(`slot${arr[s]}.port${p}`);
                  }
                }
                break;
              default:
                for (let i = 1; i < 17; i++) {
                  defaultPorts.push(`BNC${i}`);
                }
                break;
            }

            defaultPorts.push("AUXA");
            defaultPorts.push("AUXB");
            // console.log(defaultPorts);
            const diff = arrayDiff(
              defaultPorts,
              state.frame.modules["slot" + n].ultrisyncLicenses
            );
            diff.forEach((port) => {
              freeUsync.push("slot" + n + "," + port);
            });
            let u = getters.getSlotLicenses("slot" + n);
            u.ultrisync.forEach((port) => {
              assignedUsync.push("slot" + n + "," + port);
            });
            //UHD
            if (state.frame.modules["slot" + n].limits.usyncUhd_ports) {
              //we have defined usyncUHD port groups
              state.frame.modules["slot" + n].limits.usyncUhd_ports.forEach(
                (portgroup) => {
                  // let pglength = portgroup.length;
                  let assignedLicenses =
                    state.frame.modules["slot" + n].ultrisyncUhdLicenses;
                  let freeports = arrayDiff(portgroup, assignedLicenses);
                  if (portgroup.length == 3 && freeports.length > 1) {
                    //   let av=arrDiff(freeports,portgroup);
                    for (let i = 0; i < freeports.length - 1; i++) {
                      freeUsyncUHD.push("slot" + n + "," + freeports[i]);
                    }
                  }
                  if (
                    portgroup.length < 3 &&
                    freeports.length == portgroup.length
                  ) {
                    freeUsyncUHD.push("slot" + n + "," + freeports[0]);
                  }
                  /* let filt = portgroup.filter(val =>
                      state.frame.modules[
                        "slot" + n
                      ].ultrisyncUhdLicenses.includes(val)
                    ); */
                  /* if (filt.length == 0) {
                      freeUsyncUHD.push("slot" + n + "," + portgroup[0]);
                    } */
                }
              );
            } else {
              const udiff = arrayDiff(
                defaultPorts,
                state.frame.modules["slot" + n].ultrisyncUhdLicenses
              );
              udiff.forEach((port) => {
                freeUsyncUHD.push("slot" + n + "," + port);
              });
            }
            let uu = getters.getSlotLicenses("slot" + n);
            uu.ultrisyncuhd.forEach((port) => {
              assignedUsyncUHD.push("slot" + n + "," + port);
            });
          }
          // }
        }
      }

      return {
        freeUsync: freeUsync,
        freeUsyncUHD: freeUsyncUHD,
        assignedUsync: assignedUsync,
        assignedUsyncUHD: assignedUsyncUHD,
      };
    },
    getFramePower(state, getters) {
      const frame = state.frame;
      let total = 0;

      for (const slot in frame.modules) {
        // console.log("slot", frame.modules[slot]);
        if (getNested(frame, "modules", slot, "type")) {
          if (getNested(frame, "modules", slot, "model") == "SWR-SDXE") {
            continue;
          }
          if (getNested(frame, "modules", slot, "limits", "pMax")) {
            total += frame.modules[slot].limits.pMax;
          }
          if ("modules" in frame.modules[slot]) {
            for (const subModule in frame.modules[slot].modules) {
              if (
                getNested(
                  frame,
                  "modules",
                  slot,
                  "modules",
                  subModule,
                  "limits",
                  "pMax"
                )
              ) {
                total += frame.modules[slot].modules[subModule].limits.pMax;
              }
            }
          }
        }
      }
      const ucci = state.parts.find((part) => part.item == "ULTRIX-UCCI");
      if (ucci != undefined && ucci.qty > 0) {
        total += ucci.pMax * ucci.qty;
      }
      let pMaxFrame = frame.limits.pMax;
      const factor = { 1: 0.94, 2: 0.91, 5: 0.85, 12: 0.82 }; //factor for fans @60% nominal
      const fs = getters.getFrameSize;
      let pTypFrame = pMaxFrame * factor[fs];
      return {
        powerMax: total + pMaxFrame,
        powerTyp: Math.ceil(total + pTypFrame),
      };
    },
    getSwrCount(state, getters) {
      let count = 0;
      if (getters.getBOMReport.cards.length > 0) {
        getters.getBOMReport.cards.forEach((ioCard) => {
          if (ioCard.item == "SWR-SDPE") {
            count += ioCard.qty;
          }
        });
      }
      return count;
    },
    getIOCountByType(state) {
      return (cardType) => {
        let res = 0;
        for (const slot in state.frame.modules) {
          if (Object.hasOwn(state.frame.modules, slot)) {
            const card = state.frame.modules[slot];
            if (card.type == cardType) {
              res++;
            }
          }
        }
        return res;
      };
    },
    getProfileRequestLegacyStatus(state) {
      return (reqID) => {
        let res = { status: false, frames: [] };
        const request = state.profile.profileData.payload?.requests?.[reqID];
        if (request == undefined) {
          return res;
        }
        for (const ch in request.chassis) {
          if (Object.hasOwn(request.chassis, ch)) {
            const element = request.chassis[ch];
            if (element.frame.model == "ULTRIX-FR5") {
              res.status = true;
              res.frames.push({ [ch]: element.name });
            }
          }
        }
        return res;
      };
    },
    getUstreamPorts(state, getters) {
      let tot = {
        uStreamOutInUse: [],
        uStreamOutAvailable: [],
        max: 0,
      };
      //let t = this.getLicenseTotals; //for update triggering
      for (const slot in state.frame.modules) {
        if (Object.hasOwn(state.frame.modules, slot)) {
          // const card = this.$store.state.frame.modules[slot];
          // const m = getNested(this.$store.state.frame.modules, slot, "modules");
          const ustreamOut = getNested(
            state.frame.modules,
            slot,
            "licenses",
            "ultristreamOut"
          );
          const slotUdanteCount =
            getNested(
              state.frame.modules,
              slot,
              "licenses",
              "ultrimixDante",
              "positions",
              "length"
            ) || 0;

          if (ustreamOut) {
            if (slotUdanteCount == 0) {
              //is vacant non-Aux uScape available?
              const u = getters.getUscapePorts.freeUscapeGroups[slot]
                .flat()
                .filter((x) => !x.includes("AUX"))
                .reverse();
              const a = getters.getUscapePorts.assignedUscape.filter((p) =>
                p.includes(slot)
              );

              if (u.length > 0 || a.length > 0) {
                tot.max += 1;
                if (ustreamOut.positions.length == 0) {
                  tot.uStreamOutAvailable.push(slot);
                } else {
                  tot.uStreamOutInUse.push(slot);
                }
              }
            }
          }
        }
      }
      return tot;
    },
    getEmptyAcuitySlots(state, getters) {
      //return array empty slots that can take acuity
      //dont include FR5 slot 0, slot 1, or FR12 slot 8 - these are for SDxE
      let res = [];
      let len = getters.getSlotsInUse.length;
      for (let i = 0; i < len; i++) {
        const el = getters.getSlotsInUse[i];

        if (el.slot == "0") {
          continue;
        }
        if (getters.getframeSize == "5" && el.slot == "1") {
          continue;
        }
        if (getters.getframeSize == "12" && el.slot == "8") {
          continue;
        }
        if (el.type.includes("BLANK")) {
          res.push(`slot${el.slot}`);
        }
      }
      return res;
    },

    /**
     * Return array of slots that have SDXE fitted
     * @returns {array} Array of slots
     */
    getSDXEslots(state, getters) {
      const gs = getters.getSlotsInUse;
      let res = [];
      for (let I = 0; I < gs.length; I++) {
        const el = gs[I];
        if (el.model == "SWR-SDXE") {
          res.push(`slot${el.slot}`);
        }
      }
      return res;
    },
  },
  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },

    slotCopyMove(state, { func, fromSlot, toSlot }) {
      //func: string ['copy','move','swap']
      // fromSlot / toSlot : string eg.'slot1'
      if (
        !checkNested(state.frame.modules, fromSlot) ||
        !checkNested(state.frame.modules, toSlot)
      ) {
        return;
      }

      const blank = UltrixData.ioModules.find(({ type }) => type === "BLANK");
      let fromCopy = JSON.parse(JSON.stringify(blank));
      let toCopy = JSON.parse(JSON.stringify(blank));
      if (checkNested(state.frame.modules, fromSlot, "model")) {
        fromCopy = JSON.parse(
          JSON.stringify(getNested(state.frame.modules, fromSlot))
        );
      }
      if (checkNested(state.frame.modules, toSlot, "model")) {
        toCopy = JSON.parse(
          JSON.stringify(getNested(state.frame.modules, toSlot))
        );
      }
      if (func == "swap") {
        Vue.set(state.frame.modules, toSlot, fromCopy);
        Vue.set(state.frame.modules, fromSlot, toCopy);
      }

      if (func == "copy") {
        Vue.set(state.frame.modules, toSlot, fromCopy);
      }
      if (func == "move") {
        Vue.set(state.frame.modules, toSlot, fromCopy);
        //delete fromSlot
        Vue.set(
          state.frame.modules,
          fromSlot,
          JSON.parse(JSON.stringify(blank))
        );
      }
    },
    copyServices(state, request_id) {
      state.services = JSON.parse(
        JSON.stringify(
          state.profile.profileData.payload.requests[request_id].services
        )
      );
    },
    loadprofileDataChassis(state, payload) {
      state.frame = JSON.parse(
        JSON.stringify(
          state.profile.profileData.payload.requests[payload.request_id]
            .chassis[payload.chassis_id].frame
        )
      );
      state.services = JSON.parse(
        JSON.stringify(
          state.profile.profileData.payload.requests[payload.request_id]
            .services
        )
      );
      state.parts = JSON.parse(
        JSON.stringify(
          state.profile.profileData.payload.requests[payload.request_id]
            .chassis[payload.chassis_id].parts
        )
      );
      state.switchers = JSON.parse(
        JSON.stringify(
          state.profile.profileData.payload.requests[payload.request_id]
            .chassis[payload.chassis_id].switchers
        )
      );
    },
    updateServices(state, { part, value }) {
      //payload: part:string, value:integer
      // console.log("part=", part, "value=", value);

      // let service = state.sevices;
      let idx = state.services.findIndex((el) => el.item == part);
      if (idx > -1) {
        state.services[idx].qty = Number(value);
      }
    },
    removeServicesByType(state, type) {
      //set services by type to zero
      state.services.forEach((service, index) => {
        if (service.item.includes(type)) {
          state.services[index].qty = 0;
        }
      });
    },
    setFrameData(state, frameSelect) {
      // console.log("frameselect", frameSelect, UltrixData[frameSelect]);
      if (!frameSelect || !UltrixData[frameSelect]) {
        return;
      }
      let framedata = "";
      framedata = JSON.parse(JSON.stringify(UltrixData[frameSelect]));
      Vue.set(state, "frame", framedata);
    },

    setPSred(state, value) {
      state.frame.psRedundancy = value;
    },
    updateParts(state, { part, value }) {
      //payload: part:string, value:integer

      let idx = state.parts.findIndex((el) => el.item == part);
      if (idx > -1) {
        state.parts[idx].qty = Number(value);
      }
    },
    updatePartsBCS(state, payload) {
      let p = JSON.parse(JSON.stringify(state.parts));

      const bcsQty = p.filter((b) => b.item === "ULTRICORE-BCS").length;

      if (payload.qty < bcsQty) {
        let d = bcsQty - payload.qty;
        for (let i = 0; i < d; i++) {
          let lastIdx = p.findLastIndex((el) => el.item == "ULTRICORE-BCS");
          if (lastIdx > -1) {
            p.splice(lastIdx, 1);
          }
        }
      }

      if (payload.qty > bcsQty) {
        let d = payload.qty - bcsQty;
        for (let b = 0; b < d; b++) {
          let newBCS = JSON.parse(JSON.stringify(UltrixData.BCS));
          newBCS.id = b + bcsQty + 1;
          newBCS.qty = 1;
          p.push(newBCS);
        }
      }

      Vue.set(state, "parts", p);
    },

    updatePartsBCSOptions(state, { BCSnum, BCSOption, Qty }) {
      //payload: BCSnum:identifying number  BCSOption: string[option] qty:integer

      let p = JSON.parse(JSON.stringify(state.parts));

      for (let idx = 0; idx < p.length; idx++) {
        if (p[idx].item == "ULTRICORE-BCS" && p[idx].id == BCSnum) {
          let BCScopy = JSON.parse(JSON.stringify(p[idx]));
          BCScopy.licenses[BCSOption].qty = Number(Qty);
          p.splice(idx, 1, BCScopy);
        }
      }
      Vue.set(state, "parts", p);
    },
    updatePartsSWR(state, { part, qty }) {
      let p = JSON.parse(JSON.stringify(state.switchers));
      let existingQty = 0;
      //delete all existing swrPart objects from parts array
      for (let n = 0; n < p.length; n++) {
        if (p[n].item === part) {
          existingQty = p[n].qty;
          p.splice(n, 1);
          n--;
        }
      }
      //get part data
      let flatList = [];

      for (const series in UltrixData.switcherParts) {
        if (Object.hasOwn(UltrixData.switcherParts, series)) {
          const seriesParts = UltrixData.switcherParts[series];
          for (const cat in seriesParts) {
            if (Object.hasOwn(seriesParts, cat)) {
              const element = seriesParts[cat];
              flatList = [...flatList, ...element];
            }
          }
        }
      }
      let partIndex = flatList.findIndex((arrItem) => arrItem.item === part);
      if (qty > 0) {
        if (partIndex > -1) {
          const newPart = JSON.parse(JSON.stringify(flatList[partIndex]));
          p.push({
            item: newPart.item,
            desc: newPart.desc,
            qty: qty,
          });
        }
      }
      if (existingQty > qty && !part.includes("REDPSU")) {
        //reduce SWR psu Options x diffQty too

        let diffQty = existingQty - qty;
        if (partIndex > -1) {
          if (flatList[partIndex].options) {
            const partOptions = flatList[partIndex].options;

            partOptions.forEach((opt) => {
              //find in state
              for (let n = 0; n < p.length; n++) {
                if (p[n].item === opt) {
                  p[n].qty -= diffQty;
                  if (p[n].qty == 0 || qty == 0) {
                    p.splice(n, 1);
                    // n--;
                  }
                }
              }
            });
          }
        }
      }

      Vue.set(state, "switchers", p);
    },

    updatePartsTSI(state, payload) {
      //payload:  qty:item qty,number, item:item type,string
      let p = state.parts;
      //delete any TLY* items from parts array
      for (let n = 0; n < p.length; n++) {
        if (p[n].item == payload.item) {
          p.splice(n, 1);
          n--;
        }
      }

      for (let b = 1; b <= Number(payload.qty); b++) {
        let newItem = JSON.parse(
          JSON.stringify(
            UltrixData.tallySystems.find(({ item }) => item === payload.item)
          )
        );
        newItem.id = b;
        // newBCS.qty = 1;
        p.push(newItem);
      }
    },
    updatePartsTSIOptions(state, { TSIitem, TSIid, TSIoption, TSIqty }) {
      let TSIobject = state.parts.find(
        ({ item, id }) => id == TSIid && item == TSIitem
      );

      // console.log({ TSIobject });

      let licObject = TSIobject.licenses.find(({ type }) => type == TSIoption);
      licObject.qty = Number(TSIqty);
    },
    updateTSParts(state, payload) {
      //payload:  qty:item qty,number, item:item type,string
      // console.log({ payload });
      //AddOrReplace item in parts store

      let p = state.parts;
      let pIndex = p.findIndex(({ item }) => item == payload.item);
      if (pIndex > -1) {
        p[pIndex] = payload;
      } else {
        p.push(payload);
      }
    },
    set_SlotLicense(state, payload) {
      //payload: int(slotn), str(type), arr(position)
      let slotn = isNaN(payload.slot) ? payload.slot : "slot" + payload.slot;
      // console.log("set slot licenses", { payload });
      if (state.frame.modules[slotn].type == "Acuity") {
        Vue.set(
          state.frame.modules[slotn].licenses[payload.type],
          "qty",
          payload.position
        );
        return;
      }
      if (payload.type.includes("ACUFR")) {
        Vue.set(
          state.frame.modules[slotn].licenses[payload.type],
          "qty",
          payload.position
        );
        return;
      }

      if (payload.type.includes("/")) {
        const licPath = payload.type.split("/");
        Vue.set(
          state.frame.modules[slotn][licPath[0]],
          licPath[1],
          payload.position
        );
      } else {
        Vue.set(state.frame.modules[slotn], payload.type, payload.position);
      }
    },
    add_SingleSlotLicense(state, { type, slot, position }) {
      //type: ultriscapeLicenses,ultrisyncLicenses etc
      //slot: 'slotx'
      // position: 'BNC1', 'slotA.port1'

      let ioMod = state.frame.modules[slot];
      switch (type) {
        case "ultriscapeLicenses":
          if (
            ioMod.limits.uscape_ports.length > ioMod.ultriscapeLicenses.length
          ) {
            const newLicenseArray = [...ioMod.ultriscapeLicenses, position];
            Vue.set(state.frame.modules[slot], type, newLicenseArray);
          }
          break;

        default:
          break;
      }
    },
    set_FrameLicense(state, payload) {
      //payload: str(type), int(state)
      const idx = state.frame.frameLicenses.findIndex(
        ({ item }) => item == payload.type
      );
      const cState = state.frame.frameLicenses[idx];
      cState.qty = Number(payload.state);
      Vue.set(state.frame.frameLicenses, idx, cState);
      // state.frame.frameLicenses.forEach((obj) => {
      //   if (obj.item == payload.type) {
      //     obj.qty = payload.state;
      //   }
      // });
    },
    add_SlotModule(state, { slotn, moduleType }) {
      //(str)module module generic type/name eg: 'HDBNC'
      //(str or int)slot_id slot number eg: 1 or "macd"
      slotn = isNaN(slotn) ? slotn : "slot" + slotn;
      // if (isNaN(slotn)) {
      // console.log(slotn, moduleType);

      let newModule = {};

      if (moduleType.includes("ACU") || moduleType.includes("CHM")) {
        let m = moduleType.replace("-", "_");
        newModule = JSON.parse(JSON.stringify(UltrixData?.[m]));
      } else {
        const result = UltrixDataioModule(moduleType);
        if (result) {
          newModule = result;
        }
      }
      // console.log("add", newModule, slotn);
      Vue.set(state.frame.modules, slotn, newModule);
    },
    add_SlotModuleByModel(state, { slotn, moduleModel }) {
      //(str)module module model eg: 'ULTRIX-IO-BP'
      //(str or int)slot_id slot number eg: 1 or "macd"
      slotn = isNaN(slotn) ? slotn : "slot" + slotn;

      const result = UltrixData.ioModules.find(
        ({ model }) => model === moduleModel
      );
      if (result) {
        const newModule = JSON.parse(JSON.stringify(result));
        Vue.set(state.frame.modules, slotn, newModule);
      }
    },
    add_SlotSubModule(state, payload) {
      const { slotName, moduleSlot, moduleType } = payload;
      // console.log("add_subMod", slotName, moduleSlot, moduleType);
      let result = UltrixData.modularIOModules.find(
        ({ type }) => type === moduleType
      );
      let newModule = JSON.parse(JSON.stringify(result));
      Vue.set(state.frame.modules[slotName].modules, [moduleSlot], newModule);
    },
    addSfpModule(state, payload) {
      // console.log("addsfpmodule", payload);

      const { port, type } = payload;
      const slot = isNaN(payload.slot) ? payload.slot : "slot" + payload.slot;
      let sfp = {};
      if (type != "" && type != "not fitted") {
        sfp = JSON.parse(
          JSON.stringify(UltrixData.SFP.find((_sfp) => _sfp.type === type))
        );
      }

      //port is subPort?
      let subModulePort = port.split(".", 2);
      if (subModulePort.length > 1) {
        Vue.set(
          state.frame.modules[slot].modules[subModulePort[0]].sfpPorts,
          [subModulePort[1]],
          sfp
        );
      } else {
        Vue.set(state.frame.modules[slot].sfpPorts, [port], sfp);
      }
    },

    removeModule(state, payload) {
      // console.log("remove payload", payload);
      let b = JSON.parse(
        JSON.stringify(
          UltrixData.ioModules.find(({ type }) => type === "BLANK")
        )
      );
      if (isNaN(payload.slot)) {
        if (payload.slot.includes("slot")) {
          state.frame.modules[payload.slot] = b;
        } else {
          state.frame.modules[payload.slot] = {};
        }
      } else {
        state.frame.modules["slot" + payload.slot] = b;
      }
    },
    slotOverwrite(state, { slot, ioMod }) {
      Vue.set(state.frame.modules, slot, ioMod);
    },
    setVAC(state, val) {
      state.VAC = val;
    },
    removeBlankModule(state, { slot }) {
      Vue.set(state.frame.modules, slot, {});
    },

    swap_BlankPanels(state, { blankType }) {
      /**
       * Swaps all blank panel types; ULTRIX-IO-BP <> ULTRIX-IO-BAF
       * @param {string} BlankType - the blank type to swap TOO
       */
      //if BAF then also check MACD and UCCI2 slots and replace as nesc.

      const slots = state.frame.modules;
      let list = {};
      for (const slot in slots) {
        if (Object.hasOwn(slots, slot)) {
          const element = slots[slot];
          if (blankType.includes("BAF")) {
            //replace BLANK with BAF
            if (
              slot.includes("macd") &&
              element?.type == undefined &&
              state.frame.model.includes("FR5")
            ) {
              list[slot] = "BLANK-MACD-BAF";
            }
            if (slot.includes("slot") && element?.type === "BLANK") {
              list[slot] = "BLANK-IO-BAF";
            }
          }
          if (!blankType.includes("BAF")) {
            //replace BAF with BLANK
            if (
              slot.includes("macd") &&
              element?.type &&
              !element.type.includes("ACU") &&
              !element.type.includes("CHM")
            ) {
              this.commit("removeModule", { slot: "macd" });
            }
            if (
              slot.includes("slot") &&
              element?.type &&
              element.type.includes("BLANK")
            ) {
              list[slot] = "BLANK";
            }
          }
        }
      }

      for (const slot in list) {
        if (Object.hasOwn(list, slot)) {
          const element = list[slot];
          this.commit("add_SlotModule", { slotn: slot, moduleType: element });
        }
      }
    },
  },
  actions: {
    resetStartState({ commit }) {
      // commit("profile/resetProfileState");
      commit("resetState");
      commit("configError/resetErrorState");
    },
    copyServices({ commit }, request_id) {
      commit("copyServices", request_id);
    },
    slotCopyMove({ commit }, payload) {
      commit("slotCopyMove", payload);
    },
    setFrameLicense({ commit, getters }, payload) {
      //payload: str(type), int(state)

      //if ulrispeed setting to disabled, remove all usync-uhd
      /*    if (payload.type.indexOf("ULTRISPEED") > -1) {
        if (payload.state == 0) {
          // console.log("setFrameLicens", payload.type, payload.state);
          //get slots used
          const slotsUsed = getters.getSlotsInUse.filter(
            (mod) => mod.type != "BLANK"
          );
          //remove all uhd usync assignments - transfer to std usync

          slotsUsed.forEach((item) => {
            if (
              this.state.frame.modules["slot" + item.slot]
                .ultrisyncUhdLicenses &&
              this.state.frame.modules["slot" + item.slot].ultrisyncUhdLicenses
                .length > 0
            ) {
              const newUsync = [
                ...this.state.frame.modules["slot" + item.slot]
                  .ultrisyncUhdLicenses,
                ...this.state.frame.modules["slot" + item.slot]
                  .ultrisyncLicenses,
              ];
              let pl = {
                slot: "slot" + item.slot,
                type: "ultrisyncUhdLicenses",
                position: Array(0),
              };
              this.commit("set_SlotLicense", pl);
              pl = {
                slot: "slot" + item.slot,
                type: "ultrisyncLicenses",
                position: newUsync,
              };
              this.commit("set_SlotLicense", pl);
              // }
            }
          });
          // slotsUsed.forEach(element => {

          // });
        }
      } */
      commit("set_FrameLicense", payload);
    },
    submitRequest({ commit }, payload) {
      commit("setIsLoading", true);
      const config = {
        headers: { "Content-Type": "application/json" },
        params: { token: payload.token, id: payload.request_id },
      };
      axios
        .post("/ajax_submit.php", "", config)
        .then(() => {
          // .then(response => {
          // console.log("save resp:", response);
          commit("setIsLoading", false);
        })
        .catch(function (error) {
          // eslint-disable-next-line no-console
          console.log("save-error:" + error);
          commit("setIsLoading", false);
        });
    },
    setSlotLicense({ commit }, payload) {
      let slotn = isNaN(payload.slot) ? payload.slot : "slot" + payload.slot;

      //check for empty slot
      if (!isEmpty(this.state.frame.modules[slotn])) {
        if (payload.type === "HD-ME" || payload.type === "UHD-ME") {
          // HD and UHD are mut.ex.
          commit("set_SlotLicense", payload);
          commit("set_SlotLicense", {
            type: payload.type == "HD-ME" ? "UHD-ME" : "HD-ME",
            slot: slotn,
            position: payload.position == 0 ? 1 : 0,
          });
          return;
        }

        commit("set_SlotLicense", payload);
      }
    },

    addSFP({ commit }, payload) {
      commit("addSfpModule", payload);
      this.dispatch("configError/license_check", payload.slot);
    },
    removeSlotModule({ commit, getters }, payload) {
      const slotn = isNaN(payload.slot) ? payload.slot : "slot" + payload.slot;
      const type = this.state.frame.modules[slotn].type;

      if (type === "Acuity" && getters.getIOCountByType("Acuity") < 2) {
        //we're removing last Acuity so remove ACUFR-CPU
        commit("removeModule", { slot: "macd" });

        //set any sevices to zero
        commit("removeServicesByType", "ACUITY");
        //removing last acuity so also remove SDxE
        const SDXEslots = getters.getSDXEslots;
        if (SDXEslots.length > 0) {
          SDXEslots.forEach((s) => {
            commit("removeModule", { slot: s });
            //if FR5 need to replace the blank in the double height slot
            if (this.state.frame.model.includes("FR5")) {
              const prevSlot = slotNumber(s) - 1;
              if (prevSlot >= 0 && prevSlot <= 7) {
                commit("add_SlotModule", {
                  slotn: `slot${prevSlot}`,
                  moduleType: "BLANK",
                });
              }
            }
            if (this.state.frame.model.includes("FR12")) {
              if (s != "slot8" || s != "slot9") {
                const prevSlot = slotNumber(s) - 1;
                if (prevSlot >= 0 && prevSlot <= 7) {
                  commit("add_SlotModule", {
                    slotn: `slot${prevSlot}`,
                    moduleType: "BLANK",
                  });
                }
              }
            }
          });
        }
      }

      if (type === "HyperMax" && getters.getIOCountByType("HyperMax") < 2) {
        //we're removing last hypermax so remove CHMFR-CPU
        commit("removeModule", { slot: "macd" });
      }

      if (type === "Carbonite" && getters.getIOCountByType("Carbonite") < 2) {
        commit("removeServicesByType", "CARBONITE");
      }
      commit("removeModule", payload);

      if (type == "SWR-SDxE (Acuity)") {
        //if we removing SWR-SDxE,  then replace prev slot blank
        if (this.state.frame.model.includes("FR5")) {
          const preSlot = slotNumber(slotn) - 1;
          if (preSlot >= 0 && preSlot <= 7) {
            commit("add_SlotModule", {
              slotn: `slot${preSlot}`,
              moduleType: "BLANK",
            });
          }
        }
        if (this.state.frame.model.includes("FR12")) {
          if (slotn != "slot8" && slotn != "slot9") {
            const preSlot = slotNumber(slotn) - 1;
            if (preSlot > 0 && preSlot < 16) {
              commit("add_SlotModule", {
                slotn: `slot${preSlot}`,
                moduleType: "BLANK",
              });
            }
          }
        }
      }

      //adjust blank Types
      if (getters.getIOCountByType("MODXIO") > 0) {
        commit("swap_BlankPanels", { blankType: "BLANK-IO-BAF" });
      } else {
        commit("swap_BlankPanels", { blankType: "BLANK" });
      }
      this.dispatch("configError/license_check", payload.slot);

      if (getters.getMinPSU["ULTRIPOWER"] < getters.getUltripower.qty) {
        commit("updateParts", {
          part: "ULTRIPOWER",
          value: getters.getUltripower.qty - 1,
        });
      }

      if (getters.getMinPSU["ULTRIPOWER-PS"] < getters.getUltripowerPS.qty) {
        commit("updateParts", {
          part: "ULTRIPOWER-PS",
          value: getters.getUltripowerPS.qty - 1,
        });
      }
    },
    addSlotModule({ commit, getters }, payload) {
      //payload{moduleType:str,slotn:num}

      commit("add_SlotModule", payload);

      if (
        payload.moduleType === "Acuity" ||
        payload.moduleType === "HyperMax"
      ) {
        //auto add ACUFR-CPU if this is the first ACUFR added
        if (
          this.state.frame.modules.macd.type === undefined ||
          this.state.frame.modules.macd.type === "BLANK" ||
          this.state.frame.modules.macd.type === "BLANK-MACD-BAF"
        ) {
          //if first ACUFR add CPU
          let cpu = {};
          cpu.slotn = "macd";
          switch (getters.getFrameType) {
            case "FR5":
              cpu.moduleType =
                payload.moduleType === "Acuity" ? "ACUFR-CPU" : "CHMFR5-CPU";
              break;
            case "NS-FR5":
              cpu.moduleType =
                payload.moduleType === "Acuity"
                  ? "ACUFR5NS-CPU"
                  : "CHMFR5NS-CPU";
              break;
            case "FR12":
              cpu.moduleType =
                payload.moduleType === "Acuity" ? "ACUFR12-CPU" : "CHMFR12-CPU";
              break;

            default:
              break;
          }
          // console.log("cpu", cpu);

          if (cpu?.moduleType) {
            commit("add_SlotModule", cpu);
          }
        }
      }
      /*  if (payload.moduleType === "MODXIO") {
        //check if blank above/left and if so repace with baffle-blank
        const num = payload.slotn.replace(/^\D+/g, "");
        const slotBefore = num - 1;
        if (slotBefore >= 0) {
          const bf = getNested(this.state.frame.modules, `slot${slotBefore}`);
          if (bf && bf.model == "ULTRIX-IO-BP") {
            commit("add_SlotModuleByModel", {
              moduleModel: "ULTRIX-IO-BAF",
              slotn: `slot${slotBefore}`,
            });
          }
        }
      } */
      /*  if (payload.moduleType === "BLANK") {
        // if adding blank check card below/right for MODX and if so repace with baffle-blank
        if (isNaN(payload.slotn)) {
          const num = payload.slotn.replace(/^\D+/g, "");
          const slotAfter = Number(num) + 1;
          const af = getNested(this.state.frame.modules, `slot${slotAfter}`);
          if (af && af.model == "ULTRIX-MODX-IO") {
            commit("add_SlotModuleByModel", {
              moduleModel: "ULTRIX-IO-BAF",
              slotn: `slot${num}`,
            });
          }
        }
      } */
      const mp = getters.getMinPSU;
      if (mp["ULTRIPOWER"] > getters.getUltripower.qty) {
        commit("updateParts", {
          part: "ULTRIPOWER",
          value: mp["ULTRIPOWER"],
        });
      }
      if (mp["ULTRIPOWER-PS"] > getters.getUltripowerPS.qty) {
        commit("updateParts", {
          part: "ULTRIPOWER-PS",
          value: mp["ULTRIPOWER-PS"],
        });
      }
      /* if (getters.getFrameSize == "2") {
        if (getters.getFramePower.powerMax > 480) {
          commit("updateParts", {
            part: "ULTRIPOWER",
            value: getters.getMinPSU["ULTRIPOWER"],
          });
        }
      }
      if (getters.getFrameSize == "5") {
        if (getters.getFramePower.powerMax > 1000) {
          commit("updateParts", {
            part: "ULTRIPOWER",
            value: getters.getMinPSU["ULTRIPOWER"],
          });
        }
      }
      if (getters.getFrameSize == "12") {
        if (getters.getFramePower.powerMax > 2000) {
          commit("updateParts", {
            part: "ULTRIPOWER",
            value: getters.getMinPSU["ULTRIPOWER"],
          });
        }
      }*/
      // if (
      //   payload.moduleType === "Acuity" ||
      //   payload.moduleType === "Carbonite"
      // ) {
      //   // if  SWR add check min PWR required

      //   if (getters.getMinPSU["ULTRIPOWER"] > getters.getUltripower.qty) {

      //   }
      //   if (getters.getMinPSU["ULTRIPOWER-PS"] > getters.getUltripowerPS.qty) {
      //     commit("updateParts", {
      //       part: "ULTRIPOWER-PS",
      //       value: getters.getMinPSU["ULTRIPOWER-PS"],
      //     });
      //   }
      // }
    },
    addSlotSubModule({ commit }, payload) {
      // const { slotName, moduleSlot, moduleType}=payload;
      if (payload.moduleType === "BLANK") {
        //remove dependent Uscape licenses
        let arr = this.state.frame.modules[
          payload.slotName
        ].ultriscapeLicenses.filter(
          (subMod) => !subMod.includes(payload.moduleSlot)
        );
        commit("set_SlotLicense", {
          slot: payload.slotName,
          type: "ultriscapeLicenses",
          position: arr,
        });
      }
      commit("add_SlotSubModule", payload);
    },

    setFrame({ commit }, frame) {
      commit("setFrameData", frame);
      //add default psu (FR1/2 included at Agile BOM level)
      if (frame !== "ULTRIX_NS_FR1" && frame !== "ULTRIX_NS_FR2") {
        const psu = UltrixData[frame].limits.psu;
        for (const part in psu.std) {
          if (Object.hasOwn(psu.std, part)) {
            commit("updateParts", { part: part, value: psu.std[part] });
          }
        }
      }
    },
    shuffleSWR({ commit, state, getters }) {
      //shuffles SWR pos 1,3,5,7 to new pos 8, 7,6, 5
      const swrMap = ["slot8", "slot7", "slot6", "slot5"];

      const swrCount = getters.getSwrCount;
      //find first SWR
      for (let count = 0; count < swrCount; count++) {
        const k = Object.keys(state.frame.modules);

        const fswrSlot = k.find((s) => {
          return state.frame.modules[s].model == "SWR-SDPE";
        });

        //take copy
        const ioCopy = JSON.parse(
          JSON.stringify(state.frame.modules[fswrSlot])
        );

        //get number of slot
        const r = /\d+/;
        let slotn = Number(fswrSlot.match(r));

        for (let curSlotn = slotn; curSlotn < 8 - count; curSlotn++) {
          commit("slotCopyMove", {
            func: "move",
            fromSlot: `slot${curSlotn + 1}`,
            toSlot: `slot${curSlotn}`,
          });
          // console.log("slotMove", ` slot${curSlotn + 1} > slot${curSlotn} `);
        }
        //insert the copy in corrent place
        commit("slotOverwrite", { slot: swrMap[count], ioMod: ioCopy });
        // console.log("slotCopyInsert", ` ${swrMap[count]} - ${ioCopy.model}`);
      }
    },
    swapBlankPanels({ commit, getters }, payload) {
      commit("swap_BlankPanels", payload);
      //add UCCI-BAF if FR5 and no second UCCI
      if (getters.getFrameSize == "5") {
        const idx = this.state.parts.findIndex(
          (el) => el.item == "ULTRIX-UCCI"
        );
        if (idx > -1) {
          if (this.state.parts[idx].qty == 0) {
            if (payload?.blankType.includes("BAF")) {
              //add UCCI-BAF
              commit("updateParts", { part: "ULTRIX-UCCI-BAF", value: 1 });
            } else {
              commit("updateParts", { part: "ULTRIX-UCCI-BAF", value: 0 });
            }
          }
        }
      }
    },
  },
});
